import { IProduct } from '@core/api/Products/types'
import { IProductContent } from '@core/prismic/types'

export function getProductPageMetaData({
  product,
  prismicContent,
  titleFallback,
  descriptionFallback,
}: {
  product: IProduct
  prismicContent?: IProductContent
  titleFallback?: string
  descriptionFallback?: string
}) {
  const prismicData = prismicContent?.data
  const { name } = product
  const seoTitle = prismicData?.seo_title || titleFallback || name

  const seoDescription =
    prismicData?.seo_description || descriptionFallback || ''

  return {
    seoTitle,
    seoDescription,
    keywords: [],
  }
}
